import store from './../store'

export default {
  path: '/projects',
  name: 'projects',
  redirect: { name: 'projects.list-page' },
  component: () => import('@/views/projects/index.vue'),
  children: [
    {
      path: '/projects',
      name: 'projects.list-page',
      component: () => import('@/views/projects/ListPage.vue'),
    },
    {
      path: '/projects/shared/:shareId',
      name: 'projects.shared-view-page',
      component: () => import('@/views/projects/SharedViewPage.vue'),
      props: true,
    },
    {
      path: '/projects/shared/:shareId/tradie/:tradieId',
      name: 'projects.shared-view-tradie',
      component: () => import('@/views/projects/SharedViewTradie.vue'),
      props: true,
    },
    {
      path: '/projects/:id',
      name: 'projects.view-page',
      component: () => import('@/views/projects/ViewPage.vue'),
    },
    {
      path: '/projects/:id/tradie/:tradieId',
      name: 'projects.view-tradie',
      component: () => import('@/views/projects/ViewTradie.vue'),
    },
  ],
  beforeEnter: async (to, from, next) => {
    // A supervisor tradie with zero assigned projects is treated like a
    // non-supervisor tradie here — nothing on this tab would render for
    // them anyway (see isActiveSupervisorTradie).
    const canEnter = (user) =>
      user.user_type === 'business_admin' ||
      (user.user_type === 'tradie' &&
        user.is_supervisor &&
        store.getters['auth/isActiveSupervisorTradie'])

    if (store.state.auth.user) {
      if (!canEnter(store.state.auth.user)) next({ name: 'page-not-found' })
      else next()
    } else {
      store
        .dispatch('auth/getAuthenticatedUser')
        .then(() => {
          if (!canEnter(store.state.auth.user)) next({ name: 'page-not-found' })
        })
        .catch(() => next({ name: 'auth.login-page' }))
        .finally(() => next())
    }
  },
}
